import LoggerMutationType from 'app/enums/LoggerMutationType'

export default function(input){

    switch(input){

        case LoggerMutationType.CREATED: return 'positive';
        case LoggerMutationType.AVAILABLE: return 'positive';
        case LoggerMutationType.DEPLOYED: return 'warning';
        case LoggerMutationType.RETURNING: return 'notice';
        case LoggerMutationType.REPAIR_PENDING: return 'grey';
        case LoggerMutationType.REPAIR_ACTIVE: return 'highlight-2';
        case LoggerMutationType.WRITTEN_OF: return 'negative';
        default: return '';
    }
}